/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preferences_Language_DescriptionInputs */



/**
* | output |
* | --- |
* | "Select your preferred language for the interface" |
*
* @param {Preferences_Language_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const preferences_language_description = /** @type {((inputs?: Preferences_Language_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preferences_Language_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wähle deine bevorzugte Sprache für die Benutzeroberfläche")
	return /** @type {LocalizedString} */ ("Select your preferred language for the interface")
});